import React, { Fragment } from 'react';
import { Logo, SignUpButton } from '.';
import { Transition, Link } from 'components';
import css from './overtake-menu.scss';

export function OvertakeMenu(props) {
  return (
    <Transition in={props.in} mountOnEnter unmountOnExit classNames={css.locals}>
      <div className={css.container}>
        <ul className={css.menu}>
          <li><Link to="/overview/">Overview</Link></li>
          <li><Link to="/features/">Features</Link></li>
          <li><Link to="/programs/">Programs</Link></li>
          <li><Link to="/about/">About</Link></li>
          <li><Link to="/contact/">Contact</Link></li>
          <li><a target="_blank" href="https://successwizard.blog">Blog</a></li>
          <li><Link to="/login/" className={css.login}>Login</Link></li>
          <li><Link to="/sign-up/" className={css.signup}><SignUpButton /></Link></li>
        </ul>
      </div>
    </Transition>
  );
}
